/* src/app/pages/login-v2/styles/_step.styles.scss */
.auth-card {
  width: 100%;
  box-sizing: border-box;
  background: var(--auth-card-bg);
  border-radius: var(--auth-card-radius);
  padding: 24px;
}
@media (max-width: 1099px) {
  .auth-card {
    padding: 16px;
  }
}
.auth-card__header {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
}
.auth-card__intro {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
  justify-content: center;
}
.auth-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.auth-email-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.auth-form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.auth-email-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.auth-email-field--error ::ng-deep .input {
  border-color: var(--danger-regular-default);
}
.auth-email-field--error ::ng-deep .p-inputtext {
  border-color: var(--danger-regular-default);
}
.auth-offer {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-top: 16px;
}
.auth-offer .p-checkbox {
  flex-shrink: 0;
  margin-top: 1px;
}
.auth-offer__text {
  font-size: 13px;
  line-height: 18px;
}
.auth-offer__text a {
  color: var(--primary-regular-default);
  text-decoration: none;
}
.auth-offer__text a:hover {
  text-decoration: underline;
}
.auth-register-note {
  margin-top: 8px;
}
.auth-card__title {
  margin: 0;
  color: var(--text-default);
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
}
.auth-card__subtitle {
  margin: 0;
  color: var(--text-label);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}
.auth-card__email {
  color: var(--text-label);
  font-weight: 500;
  word-break: break-all;
}
.auth-code-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
}
.auth-code-error {
  margin: 0;
  color: var(--danger-regular-default);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.auth-social {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.auth-social__title {
  margin: 0;
  color: var(--text-default);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}
.auth-social__grid {
  display: flex;
  gap: 4px;
}
.auth-social__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;
  border-radius: 4px;
  background: var(--secondary-subtle-default);
  cursor: not-allowed;
  opacity: 0.72;
}
.auth-social__icon {
  display: block;
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.auth-social__icon--t-bank {
  width: 24px;
  height: 13px;
}
.auth-version {
  margin: 0;
  text-align: center;
  color: var(--text-hint);
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
}
.auth-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: var(--text-label);
  cursor: pointer;
  padding: 0;
}
.auth-back--round {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border: 1px solid var(--secondary-regular-default);
  border-radius: 50%;
  background: var(--card-default);
  color: var(--text-default);
}
.auth-back:focus-visible {
  outline: 2px solid var(--primary-regular-default);
  outline-offset: 2px;
}
.auth-error {
  margin: 0;
  color: var(--danger-regular-default);
  font-size: 13px;
  line-height: 18px;
  text-align: left;
}
.auth-link-button {
  border: 0;
  background: transparent;
  color: var(--primary-regular-default);
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  padding: 0;
  text-align: left;
}
.auth-link-button--muted {
  color: var(--text-label);
}
.auth-account-list {
  list-style: none;
  margin: 24px 0;
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-Small, 8px);
}
.auth-account-card {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-Regular, 16px);
  border: none;
  border-radius: 0;
  background: transparent;
  padding: 0 0 12px;
  cursor: pointer;
  text-align: left;
  box-shadow: inset 0 -2px 0 0 var(--primary-subtle-default, #e8f2ff);
}
.auth-account-list__item:last-child .auth-account-card {
  box-shadow: none;
  padding-bottom: 0;
}
.auth-account-card:hover .auth-account-card__name {
  color: var(--primary-regular-default);
}
.auth-account-card:focus-visible {
  outline: 2px solid var(--primary-regular-default);
  outline-offset: 2px;
  border-radius: 4px;
}
.auth-account-card__body {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  flex: 1;
}
.auth-account-card__name {
  color: var(--text-default);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.auth-account-card__meta {
  color: var(--text-default);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
.auth-account-card__shift {
  color: var(--success-regular-default);
  font-size: 12px;
  line-height: 16px;
}
.auth-account-card__icon {
  flex-shrink: 0;
  color: var(--text-label);
  font-size: 16px;
  width: 36px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.auth-pvz-address-container {
  display: flex;
  flex-direction: row;
  gap: 3px;
  margin-bottom: 16px;
}
.auth-pvz-address-separator {
  color: var(--text-label);
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}
.auth-pvz-address {
  margin: 0;
  color: var(--text-label);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.auth-pvz-date {
  color: var(--text-label);
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}
:host {
  display: block;
  width: 100%;
  box-sizing: border-box;
}
/*# sourceMappingURL=_step.styles.css.map */
